import { useContext } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./GasLiftManifold.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";

 import { trackPageVisit } from "../competency/PageTracker";



 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }



function GasLiftManifold() {

        useEffect(() => {
  
    trackPageVisit("GasLiftManifold");
  
  }, []);

  const {  wellSignals, valves, toggleValve, setTransmitters  } = useContext(WellContext);

      
   const DEFAULT_VALVES = {
            FCV_10801: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10802: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_10803: { mode: "Manual", opening: 0, sp: "", pv: "" },
            };

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("GasLiftManifold_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_10801: { ...DEFAULT_VALVES.FCV_10801, ...parsed.FCV_10801 },
      FCV_10802: { ...DEFAULT_VALVES.FCV_10802, ...parsed.FCV_10802 },
      FCV_10803: { ...DEFAULT_VALVES.FCV_10803, ...parsed.FCV_10803 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});


/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("GasLiftManifold_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};




  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };







              /* 🔥 TRANSMITTER OUTPUTS */


const isXV10801Open = valves.XV_10801 === false;
const isXV10802Open = valves.XV_10802 === false;
const isXV10803Open = valves.XV_10803 === false;
const isXV10804Open = valves.XV_10804 === false;
const isXV10805Open = valves.XV_10805 === false;





const FIC_10801 = isXV10805Open ? 53.534 : 0;
const PT_10801 = isXV10805Open ? 19.581 : 0.03;
const TT_10801 = isXV10805Open ? 18.985 : 26.43;



const FIC_10802 = 32.453 * (valveData.FCV_10801.opening)/100;
const FIC_10803 = 22.453 * (valveData.FCV_10802.opening)/100;
const FIC_10804 = 9.453 * (valveData.FCV_10803.opening)/100;

const FIC_10805 = isXV10803Open ? 5.534 : 0;
const FIC_10806 = isXV10804Open ? 3.534 : 0;

const FIC_10807 = FIC_10801 - FIC_10802 - FIC_10803 - FIC_10804 + FIC_10805 + FIC_10806;

const FIC_10808 = isXV10801Open ? FIC_10807 : 0;
const PT_10808 = isXV10801Open ? PT_10801 : 0.03;

const FIC_10809 = isXV10802Open ? FIC_10807 : 0;
const PT_10809 = isXV10802Open ? PT_10801 : 0.03;



  useEffect(() => {
      localStorage.setItem("FIC_10808", FIC_10808);
    }, [FIC_10808]);

  useEffect(() => {
      localStorage.setItem("PT_10808", PT_10808);
    }, [PT_10808]);

  useEffect(() => {
      localStorage.setItem("FIC_10809", FIC_10809);
    }, [FIC_10809]);

  useEffect(() => {
      localStorage.setItem("PT_10809", PT_10809);
    }, [PT_10809]);





  return (
    <div className="GasLiftManifold-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "-20px",
        left: "243px",
        color: "white",
        background: "rgb(29, 4, 253)",
        padding: "2.2px 289px"
      }}>
        GAS LIFT MANIFOLD
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      {/* XV-10801 */}
      <Valve
        className="XV-10801"
        tag="XV_10801"
        x={140}
        y={97}
        isClosed={valves.XV_10801}
        toggle={toggleValve}
      />

      {/* XV-10802 */}
      <Valve
        className="XV-10802"
        tag="XV_10802"
        x={118}
        y={177}
        isClosed={valves.XV_10802}
        toggle={toggleValve}
      />

        {/* XV-10803 */}
      <Valve
        className="XV-10803"
        tag="XV_10803"
        x={725}
        y={123}
        isClosed={valves.XV_10803}
        toggle={toggleValve}
      />

        {/* XV-108034 */}
      <Valve
        className="XV-10804"
        tag="XV_10804"
        x={705}
        y={63}
        isClosed={valves.XV_10804}
        toggle={toggleValve}
      />

        {/* XV-10805 */}
      <Valve
        className="XV-10805"
        tag="XV_10805"
        x={1105}
        y={284}
        isClosed={valves.XV_10805}
        toggle={toggleValve}
      />


   


      

      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10801 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10801"
          style={{ position: "absolute", left: 973, top: 120 }}  onClick={() => openPanel("FCV_10801")}>
          
          <defs>
            <linearGradient id="metal_10801">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10801)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10801)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10802 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10802"
          style={{ position: "absolute", left: 783, top: 377 }}  onClick={() => openPanel("FCV_10802")}>
          
          <defs>
            <linearGradient id="metal_10802">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10802)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10802)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-10803 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10803"
          style={{ position: "absolute", left: 563, top: 455 }}  onClick={() => openPanel("FCV_10803")}>
          
          <defs>
            <linearGradient id="metal_10803">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10803)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10803)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        
      {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={valveData.FCV_10801.opening}
        x={998}
        y={165}
      />
      
      <ValveOutput
        value={valveData.FCV_10802.opening}
        x={805}
        y={420}
      />

      <ValveOutput
        value={valveData.FCV_10803.opening}
        x={593}
        y={495}
      />



      <Transmitter
          tag="FIC-10801"
          value={[FIC_10801]}
          x={1023}
          y={275}
          unit="SCF/S"
          max={70}
          HH={65}
          H={60}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM GAS LIFT UNIT"
        />

        <Transmitter
          tag="PT-10801"
          value={PT_10801}
          x={735}
          y={275}
          unit="MPa"
          max={25}
          HH={20}
          H={18}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF GAS FROM GAS LIFT UNIT"
        />

        <Transmitter
          tag="TT-10801"
          value={TT_10801}
          x={848}
          y={275}
          unit="°C"
          max={70}
          HH={65}
          H={50}
          L={10}
          LL={5}
          c="lime"
          description="TEMPERATURE OF GAS FROM GAS LIFT UNIT"
        />

        <Transmitter
          tag="FIC-10802"
          value={[FIC_10802]}
          x={1073}
          y={119}
          unit="SCF/S"
          max={30}
          HH={25}
          H={20}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM GAS LIFT MANIFOLD TO PIG LAUNCHER FOR PURGING"
        />

        <Transmitter
          tag="FIC-10803"
          value={[FIC_10803]}
          x={923}
          y={389}
          unit="SCF/S"
          max={30}
          HH={25}
          H={20}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM GAS LIFT MANIFOLD TO FLARE HEADER"
        />

        <Transmitter
          tag="FIC-10804"
          value={[FIC_10804]}
          x={700}
          y={453}
          unit="SCF/S"
          max={30}
          HH={25}
          H={20}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM GAS LIFT MANIFOLD TO VENT HEADER"
        />

        <Transmitter
          tag="FIC-10805"
          value={[FIC_10805]}
          x={636}
          y={121}
          unit="LPM"
          max={30}
          HH={25}
          H={20}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITION FROM CORROSION INHIBITOR UNIT"
        />

        <Transmitter
          tag="FIC-10806"
          value={[FIC_10806]}
          x={586}
          y={70}
          unit="LPM"
          max={30}
          HH={25}
          H={20}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF METHANOL FROM BOAT LANDING OR METHANOL UNIT"
        />

        <Transmitter
          tag="FIC-10807"
          value={[FIC_10807]}
          x={328}
          y={338}
          unit="SCF/S"
          max={70}
          HH={65}
          H={60}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS ON MAIN GAS LIFT HEADER"
        />

        <Transmitter
          tag="FIC-10808"
          value={[FIC_10808]}
          x={300}
          y={153}
          unit="SCF/S"
          max={70}
          HH={65}
          H={60}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM GAS LIFT HEADER TO NK-1 WELLHEAD"
        />

        <Transmitter
          tag="PT-10808"
          value={PT_10808}
          x={300}
          y={118}
          unit="MPa"
          max={25}
          HH={20}
          H={18}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF GAS FROM GAS LIFT HEADER TO NK-1 WELLHEAD"
        />

        <Transmitter
          tag="FIC-10809"
          value={[FIC_10809]}
          x={90}
          y={238}
          unit="SCF/S"
          max={70}
          HH={65}
          H={60}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF GAS FROM GAS LIFT HEADER TO NK-2 WELLHEAD"
        />

        <Transmitter
          tag="PT-10809"
          value={PT_10809}
          x={93}
          y={275}
          unit="MPa"
          max={25}
          HH={20}
          H={18}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF GAS FROM GAS LIFT HEADER TO NK-2 WELLHEAD"
        />


      

    </div>
  );
}

export default GasLiftManifold;